import { memo } from 'react'
import { useTranslate } from 'react-polyglot'
import { Menu } from '@getgo/chameleon-web-react-wrapper'
import { Box } from '@material-ui/core'

import { usePartnerLinks } from 'hooks'
import PartnerToolsDrawerSection from './PartnerToolsDrawerSection'
import PartnerToolsDrawerSkeleton from './PartnerToolsDrawerSkeleton'

const PartnerToolsDrawer = () => {
  const t = useTranslate()
  const { loading, gtaPartnerEditionLinks, partnerExchangeLinks, learnMoreLinks } = usePartnerLinks()

  if (loading) {
    return <PartnerToolsDrawerSkeleton />
  }

  return (
    <Box ml={'var(--goto-spacing-04)'}>
      <Menu>
        <PartnerToolsDrawerSection links={gtaPartnerEditionLinks} title={t('GoTo Admin Partner Edition')} />
        <PartnerToolsDrawerSection links={partnerExchangeLinks} title={t('Partner Exchange')} />
        <PartnerToolsDrawerSection links={learnMoreLinks} title={t('Learn more')} />
      </Menu>
    </Box>
  )
}

export default memo(PartnerToolsDrawer)
